import { HeaderSearch, SortColumns } from 'shared/interfaces';
import { Filters } from 'shared/types';

export const SET_PAGE = 'SET_PAGE';
export const SET_START = 'SET_START';
export const SET_SORT = 'SET_SORT';
export const SET_FILTER = 'SET_FILTER';
export const SET_STATUS = 'SET_STATUS';
export const SET_HEADER_SEARCH = 'SET_HEADER_SEARCH';
export const RESET_SEARCH_PARAMS = 'RESET_SEARCH_PARAMS';

export interface ListingSearchState {
  query: string;
  page: number;
  start: number;
  size: number;
  sort: SortColumns | null;
  filter: Filters | null;
  status: string | null;
  search: HeaderSearch | null;
}

interface SetListingsPage {
  type: typeof SET_PAGE;
  page: number;
}

interface SetListingsStart {
  type: typeof SET_START;
  start: number;
}

interface SetListingsSort {
  type: typeof SET_SORT;
  sort: SortColumns;
}
interface ResetSearchParams {
  type: typeof RESET_SEARCH_PARAMS;
}

interface SetListingsFilter {
  type: typeof SET_FILTER;
  filter: Filters;
}

interface SetListingsStatus {
  type: typeof SET_STATUS;
  status: string | null;
}
interface SetHeaderSearch {
  type: typeof SET_HEADER_SEARCH;
  search: HeaderSearch | null;
}

export type ListingSearchActionTypes =
  | SetListingsPage
  | SetListingsStart
  | SetListingsSort
  | SetListingsFilter
  | SetListingsStatus
  | SetHeaderSearch
  | ResetSearchParams;
